import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, PartialObserver, Subscription } from 'rxjs';
import { CLIENT_STICKER_PART_TYPE } from 'src/app/model/product/windowsticker/client-sticker-part';
import { ClientWindowSticker } from 'src/app/model/product/windowsticker/client-windowsticker';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { NonIPBoardSummaryComponent } from '../non-ip-board-summary.component';
import { ClientWindowStickerSummaryHelper } from './helper/client-window-sticker-summary-helper';

@Component({
  selector: 'client-window-sticker-summary',
  templateUrl: './client-window-sticker-summary.component.html',
  styleUrls: ['./client-window-sticker-summary.component.scss']
})
export class ClientWindowStickerSummaryComponent
  extends NonIPBoardSummaryComponent
  implements OnInit, OnDestroy {
  // have to manage subscriptions here since this component already extends a different class
  private subscriptions: Subscription[] = [];

  CLIENT_STICKER_PART_TYPE = CLIENT_STICKER_PART_TYPE;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.calculateTypeLabel();
    this.initializeSubscriptions();
  }

  ngOnDestroy(): void {
    if (this.subscriptions != null) {
      this.subscriptions.forEach(s => {
        if (s != null) {
          s.unsubscribe();
        }
      });
      this.subscriptions = null;
    }
  }

  private calculateTypeLabel(): void {
    (<ClientWindowSticker>(
      this.product
    )).calculatedTypeLabel = ClientWindowStickerSummaryHelper.calculateTypeLabel(
      <ClientWindowSticker>this.product
    );
  }

  private initializeSubscriptions(): void {
    this.addSubscription(
      this.projectDisplayObservableService.getProductPartTypeChangedSubscribable(),
      () => {
        this.calculateTypeLabel();
      }
    );
  }

  private addSubscription<T>(
    observable: Observable<T>,
    successCallback: (o: T) => void,
    errorCallback?: (any) => void
  ): void {
    const observer: PartialObserver<T> = {
      next: successCallback,
      error: errorCallback
      //complete can be added if needed.
    };

    const subscription = observable.subscribe(observer);

    if (this.subscriptions == null) {
      this.subscriptions = [subscription];
    } else {
      this.subscriptions.push(subscription);
    }
  }
}
